export default {
  valueType: 'BankCardNumber',
  itemProps: {
    label: '银行卡号',
  },
  BValue: '',
  outerAttr: {
    rules: [{ required: true }],
  },
  innerStyle: {
    width: '50%',
    minWidth: "300px"
  },
};
